import { useParams, useNavigate } from "react-router-dom";
import { graphql } from "@apollo/client/react/hoc";
import gql from "graphql-tag";
import format from "date-fns/format";

import React from "react";
import { connect } from "react-redux";
import Loading from "./loading";

import Link from "core/Link";

let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
});

class InvoiceList extends React.Component {
    constructor(props) {
        super(props);

        props.data.refetch();

        this.state = {};
    }

    editReceipt(charge, editPermaLink, e) {
        e.preventDefault();

        this.props.navigate(`${editPermaLink}`);
    }

    render() {
        if (this.props.data.charges) {
            if (this.props.data.charges.length > 0) {
                let charges = this.renderCharges();

                return (
                    <section>
                        <header>
                            <h3>Invoices</h3>
                        </header>
                        <table className="billing-history-table">
                            <tbody>
                                <tr className="row">
                                    <th className="col-xs-2">Date</th>
                                    <th className="col-xs-4">Description</th>
                                    <th className="col-xs-3">Charge ID</th>
                                    <th className="col-xs-3">Amount</th>
                                </tr>
                                {charges}
                            </tbody>
                        </table>
                    </section>
                );
            } else {
                return (
                    <div
                        className="display-flex"
                        style={{
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                            color: "#CCCCCC",
                            marginTop: "200px"
                        }}
                    >
                        - You don't have any invoices yet -{" "}
                    </div>
                );
            }
        } else {
            return <Loading />;
        }
    }

    renderCharges() {
        let charges = [];
        let { userId, creator } = this.props;

        this.props.data.charges.forEach(charge => {
            let editPermaLink,
                description,
                rowClasses = ["row", "data"],
                chargeAmount = formatter.format(
                    (charge.amount / 100).toFixed(2)
                ),
                refundedText;

            let chargeId = charge.stripeId;
            if (charge.paypalId) {
                chargeId = charge.paypalId;
            }

            if (!creator) {
                editPermaLink = `/${this.props.username}/settings/invoices/${chargeId}/edit/`;
            } else {
                editPermaLink = `/fort/members/${this.props.creator.id}/customer/invoices/${chargeId}/edit/`;
            }
            // If the charge failed, show why in the description.
            if (charge.failureCode) {
                rowClasses.push("failed-payment-row");
                description = charge.failureMessage;
            } else {
                // Assuming any successful charge without subscription IS a subscription.
                if (charge.description) {
                    description = charge.description;
                } else {
                    description = "Subscription";
                }
            }

            // If charge amount is negative, then wrap in parenthesis
            if (charge.refunded) {
                refundedText = (
                    <em style={{ fontStyle: "italic" }}>
                        Refunded{" "}
                        {formatter.format(
                            (charge.amountRefunded / 100).toFixed(2)
                        )}
                    </em>
                );
            }

            charges.push(
                <tr key={charge.created} className={rowClasses.join(" ")}>
                    <td
                        className="col-xs-2"
                        title={format(new Date(charge.created), "MMM DD, YYYY")}
                    >
                        {format(new Date(charge.created), "MM/DD/YYYY")}
                    </td>
                    <td className="col-xs-4">
                        <p>{description}</p>
                        {refundedText}
                    </td>
                    <td className="col-xs-3 payment-row-charge-id">
                        {chargeId}
                    </td>
                    <td
                        className="col-xs-3 display-flex"
                        title={chargeAmount + " USD"}
                    >
                        <span className="payment-row-ammount">
                            {chargeAmount}
                        </span>
                        <span className="payment-row-actions">
                            <Link
                                target="_blank"
                                title="View PDF"
                                href={`/${
                                    userId === undefined
                                        ? this.props.creator.username
                                        : this.props.username
                                }/settings/invoices/${chargeId}/`}
                                styleType="primary"
                                size="md"
                            >
                                PDF
                            </Link>
                            <a
                                href={`${editPermaLink}`}
                                className="ui_pencil margin-l-s"
                                title="Edit extra billing information for this invoice"
                                onClick={e =>
                                    this.editReceipt(charge, editPermaLink, e)
                                }
                            />
                        </span>
                    </td>
                </tr>
            );
        });

        return charges;
    }
}

function mapStateToProps(state, ownProps) {
    let creator, userId;
    if (state.creator.keys && state.creator.keys[0]) {
        creator = state.creator[state.creator.keys[0]];
        userId = creator.id;
    } else if (state.user) {
        let user = state.user;
        userId = user.id;
    }
    if (global._pageConfig && global._pageConfig.billing_user_id) {
        userId = global._pageConfig.billing_user_id;
    }

    return { userId, creator };
}

const invoiceListQuery = gql`
    query InvoiceListQuery($userId: ID!) {
        charges: billingHistory(userId: $userId) {
            created
            stripeId
            paypalId
            description
            amount
            failureCode
            failureMessage
            refunded
            amountRefunded
        }
    }
`;

const InvoiceListQuery = graphql(invoiceListQuery, {
    options: ({ userId }) => ({
        variables: { userId }
    })
})(InvoiceList);

const ConnectedInvoiceList = connect(mapStateToProps, {})(InvoiceListQuery);

// Wrapper component to provide route params and navigation
const InvoiceListWithRouter = () => {
    const params = useParams();
    const navigate = useNavigate();
    return <ConnectedInvoiceList username={params.username} navigate={navigate} />;
};

export default InvoiceListWithRouter;
